/* Cart drawer scroll shadows (Gymshark-style).
   Toggles .kfk-shadow-top / .kfk-shadow-bottom on #cart-drawer based on the
   inner scroller position, so the header/footer bars cast a soft shadow only
   while there is hidden content beyond them. CSS lives in kfk-global.css. */
(function () {
  var TOP = 'kfk-shadow-top';
  var BOTTOM = 'kfk-shadow-bottom';
  function host() { return document.querySelector('#cart-drawer'); }
  function scroller() { return document.querySelector('#cart-drawer .f-drawer__scroller'); }

  function update() {
    var h = host(), s = scroller();
    if (!h || !s) return;
    var overflow = s.scrollHeight - s.clientHeight;
    var canScroll = overflow > 1;
    h.classList.toggle(TOP, canScroll && s.scrollTop > 1);
    h.classList.toggle(BOTTOM, canScroll && (overflow - s.scrollTop) > 1);
  }

  // Live scroll — capture phase so we catch the inner scroller (scroll doesn't bubble).
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('f-drawer__scroller')) update();
  }, true);

  window.addEventListener('resize', update);

  // Recompute when the drawer opens or its contents re-render (cart update, recs inject).
  var mo = new MutationObserver(function () { update(); });
  function observe() {
    var h = host();
    if (h && !h.__kfkShadowObserved) {
      h.__kfkShadowObserved = true;
      mo.observe(h, { childList: true, subtree: true, attributes: true });
    }
  }

  // Opening the drawer / changing quantity is a click — recompute after the animation.
  document.addEventListener('click', function () {
    setTimeout(update, 350);
    setTimeout(update, 700);
  }, true);

  function init() { observe(); update(); }
  if (document.readyState !== 'loading') { init(); }
  document.addEventListener('DOMContentLoaded', init);
})();
